(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cbs-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(root) {
    var list = root.querySelector('[data-cbs-slides]');
    var slides = list ? [].slice.call(list.children) : [];
    var thumbs = [].slice.call(root.querySelectorAll('[data-cbs-thumb]'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function setActive(i) {
      thumbs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-active', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    function go(i) {
      if (!slides[i]) return;
      list.scrollTo({ left: slides[i].offsetLeft - list.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (list && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.6) setActive(parseInt(e.target.getAttribute('data-i'), 10)); });
      }, { root: list, threshold: 0.6 });
      slides.forEach(function (sl) { io.observe(sl); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var modal = root.querySelector('[data-cbs-modal]');
    if (modal && typeof modal.showModal === 'function') {
      root.querySelectorAll('[data-cbs-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          var img = modal.querySelector('[data-mi="' + b.getAttribute('data-cbs-open') + '"]');
          if (!img) return;
          modal.showModal(); img.scrollIntoView({ block: 'start' });
        });
      });
      var closeBtn = modal.querySelector('[data-cbs-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }

    var form = root.querySelector('form[data-cbs-form]');
    var btn = root.querySelector('[data-cbs-atc]');
    var msg = root.querySelector('[data-cbs-msg]');
    var dataEl = root.querySelector('[data-cbs-variants]');
    var data = { variants: {} };
    try { if (dataEl) data = JSON.parse(dataEl.textContent); } catch (e) {}
    if (!form || !btn) return;
    var busy = false;
    function add() {
      if (busy || btn.disabled) return;
      busy = true; btn.setAttribute('aria-busy', 'true'); if (msg) msg.textContent = '';
      var body = new FormData(form);
      if (!body.get('quantity')) body.set('quantity', '1');
      fetch(root.getAttribute('data-cart-add') || '/cart/add.js', { method: 'POST', body: body, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }).catch(function () { return { ok: r.ok, j: {} }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to cart. Please try again.');
          var inp = form.querySelector('input[name="id"]'); var v = inp && data.variants[inp.value];
          if (window.fbq && v) { try { window.fbq('track', 'AddToCart', { content_ids: [String(data.product_id)], content_type: 'product', value: v.raw / 100, currency: data.currency }); } catch (e) {} }
          if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
          if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
          else document.dispatchEvent(new CustomEvent('upcart:open'));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function (err) { if (msg) msg.textContent = err && err.message ? err.message : 'Could not add to cart.'; })
        .then(function () { busy = false; btn.removeAttribute('aria-busy'); });
    }
    btn.addEventListener('click', add);
    form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
  }
  function boot() {
    document.querySelectorAll('.cbs-hero[data-cbs-hero]').forEach(function (r) {
      if (r.getAttribute('data-cbs-init')) return;
      r.setAttribute('data-cbs-init', '1');
      initHero(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cbs-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot() {
    document.querySelectorAll('.cbs-rs').forEach(function (root) {
      if (root.getAttribute('data-init')) return; root.setAttribute('data-init', '1');
      var track = root.querySelector('[data-cbs-rs-track]');
      var dots = root.querySelector('[data-cbs-rs-dots]');
      if (!track || !dots) return;
      var cards = Array.from(track.children);
      var page = 0, perPage = 3, pages = 1;
      function draw() {
        perPage = window.matchMedia('(min-width: 761px)').matches ? 3 : 1;
        pages = Math.ceil(cards.length / perPage);
        dots.replaceChildren();
        for (var i = 0; i < pages; i++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'cbs-rs__dot'; b.dataset.page = i;
          b.setAttribute('aria-label', 'Show stories page ' + (i + 1));
          b.addEventListener('click', function () { go(Number(this.dataset.page)); });
          dots.appendChild(b);
        }
        sync();
      }
      function sync() {
        var step = cards[0].getBoundingClientRect().width + 24;
        page = Math.min(pages - 1, Math.max(0, Math.round(track.scrollLeft / (step * perPage))));
        Array.from(dots.children).forEach(function (d, i) { d.setAttribute('aria-current', i === page ? 'true' : 'false'); });
      }
      function go(n) {
        page = (n + pages) % pages;
        var step = cards[0].getBoundingClientRect().width + 24;
        track.scrollTo({ left: page * perPage * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      root.querySelectorAll('.cbs-rs__arrow').forEach(function (b) {
        b.addEventListener('click', function () { go(page + Number(b.dataset.dir)); });
      });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', draw);
      draw();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elastin-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(root) {
    var list = root.querySelector('[data-elastin-slides]');
    var slides = list ? [].slice.call(list.children) : [];
    var thumbs = [].slice.call(root.querySelectorAll('[data-elastin-thumb]'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function setActive(i) {
      thumbs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-active', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    function go(i) {
      if (!slides[i]) return;
      list.scrollTo({ left: slides[i].offsetLeft - list.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (list && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.6) setActive(parseInt(e.target.getAttribute('data-i'), 10)); });
      }, { root: list, threshold: 0.6 });
      slides.forEach(function (sl) { io.observe(sl); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var modal = root.querySelector('[data-elastin-modal]');
    if (modal && typeof modal.showModal === 'function') {
      root.querySelectorAll('[data-elastin-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          var img = modal.querySelector('[data-mi="' + b.getAttribute('data-elastin-open') + '"]');
          if (!img) return;
          modal.showModal(); img.scrollIntoView({ block: 'start' });
        });
      });
      var closeBtn = modal.querySelector('[data-elastin-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }

    var form = root.querySelector('form[data-elastin-form]');
    var btn = root.querySelector('[data-elastin-atc]');
    var msg = root.querySelector('[data-elastin-msg]');
    var dataEl = root.querySelector('[data-elastin-variants]');
    var data = { variants: {} };
    try { if (dataEl) data = JSON.parse(dataEl.textContent); } catch (e) {}
    if (!form || !btn) return;
    var busy = false;
    function add() {
      if (busy || btn.disabled) return;
      busy = true; btn.setAttribute('aria-busy', 'true'); if (msg) msg.textContent = '';
      var body = new FormData(form);
      if (!body.get('quantity')) body.set('quantity', '1');
      fetch(root.getAttribute('data-cart-add') || '/cart/add.js', { method: 'POST', body: body, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }).catch(function () { return { ok: r.ok, j: {} }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to cart. Please try again.');
          var inp = form.querySelector('input[name="id"]'); var v = inp && data.variants[inp.value];
          if (window.fbq && v) { try { window.fbq('track', 'AddToCart', { content_ids: [String(data.product_id)], content_type: 'product', value: v.raw / 100, currency: data.currency }); } catch (e) {} }
          if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
          if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
          else document.dispatchEvent(new CustomEvent('upcart:open'));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function (err) { if (msg) msg.textContent = err && err.message ? err.message : 'Could not add to cart.'; })
        .then(function () { busy = false; btn.removeAttribute('aria-busy'); });
    }
    btn.addEventListener('click', add);
    form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
  }
  function boot() {
    document.querySelectorAll('.elastin-hero[data-elastin-hero]').forEach(function (r) {
      if (r.getAttribute('data-elastin-init')) return;
      r.setAttribute('data-elastin-init', '1');
      initHero(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntk-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(root) {
    var list = root.querySelector('[data-ntk-slides]');
    var slides = list ? [].slice.call(list.children) : [];
    var thumbs = [].slice.call(root.querySelectorAll('[data-ntk-thumb]'));
    var dots = [].slice.call(root.querySelectorAll('[data-ntk-dot]'));
    var tlist = root.querySelector('[data-ntk-thumbs]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var beh = reduce ? 'auto' : 'smooth';
    var cur = 0;
    function setActive(i) {
      cur = i;
      thumbs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-active', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (tlist && thumbs[i]) {
        var t = thumbs[i].parentNode, l = t.offsetLeft - tlist.offsetLeft, r = l + t.offsetWidth;
        if (l < tlist.scrollLeft || r > tlist.scrollLeft + tlist.clientWidth) tlist.scrollTo({ left: l, behavior: beh });
      }
    }
    function go(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      list.scrollTo({ left: slides[i].offsetLeft - list.offsetLeft, behavior: beh });
    }
    if (list && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.6) setActive(parseInt(e.target.getAttribute('data-i'), 10)); });
      }, { root: list, threshold: 0.6 });
      slides.forEach(function (sl) { io.observe(sl); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    root.querySelectorAll('[data-ntk-prev]').forEach(function (b) { b.addEventListener('click', function () { go(cur - 1); }); });
    root.querySelectorAll('[data-ntk-next]').forEach(function (b) { b.addEventListener('click', function () { go(cur + 1); }); });
    if (tlist) {
      root.querySelectorAll('[data-ntk-tprev]').forEach(function (b) { b.addEventListener('click', function () { tlist.scrollBy({ left: -tlist.clientWidth, behavior: beh }); }); });
      root.querySelectorAll('[data-ntk-tnext]').forEach(function (b) { b.addEventListener('click', function () { tlist.scrollBy({ left: tlist.clientWidth, behavior: beh }); }); });
    }
    var modal = root.querySelector('[data-ntk-modal]');
    if (modal && typeof modal.showModal === 'function') {
      root.querySelectorAll('[data-ntk-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          modal.showModal();
          var img = modal.querySelector('[data-mi="' + b.getAttribute('data-ntk-open') + '"]');
          if (img) img.scrollIntoView({ block: 'start' });
        });
      });
      var closeBtn = modal.querySelector('[data-ntk-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }

    var form = root.querySelector('form[data-ntk-form]');
    var btn = root.querySelector('[data-ntk-atc]');
    var priceEl = root.querySelector('[data-ntk-price]');
    var msg = root.querySelector('[data-ntk-msg]');
    var dataEl = root.querySelector('[data-ntk-variants]');
    var data = { variants: {} };
    try { if (dataEl) data = JSON.parse(dataEl.textContent); } catch (e) {}
    var sep = priceEl ? (priceEl.getAttribute('data-sep') || '') : '';
    function currentId() { var inp = form && form.querySelector('input[name="id"]'); return inp ? inp.value : ''; }
    function sync() {
      var v = data.variants[currentId()];
      if (v && priceEl) priceEl.textContent = v.price + (sep ? ' ' + sep : '');
    }
    if (form && btn) {
      if ('MutationObserver' in window) new MutationObserver(function () { sync(); }).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked'] });
      form.addEventListener('change', function () { window.requestAnimationFrame(sync); });
      form.addEventListener('click', function () { window.setTimeout(sync, 60); });
      document.addEventListener('variant:change', sync);
      sync();
      var busy = false;
      var add = function () {
        if (busy || btn.disabled) return;
        busy = true; btn.setAttribute('aria-busy', 'true'); if (msg) msg.textContent = '';
        var body = new FormData(form);
        if (!body.get('quantity')) body.set('quantity', '1');
        fetch(root.getAttribute('data-cart-add') || '/cart/add.js', { method: 'POST', body: body, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }).catch(function () { return { ok: r.ok, j: {} }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to cart. Please try again.');
            var v = data.variants[currentId()];
            if (window.fbq && v) { try { window.fbq('track', 'AddToCart', { content_ids: [String(data.product_id)], content_type: 'product', value: v.raw / 100, currency: data.currency, contents: [{ id: currentId(), quantity: parseInt(body.get('quantity'), 10) || 1 }] }); } catch (e) {} }
            if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
            if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
            else document.dispatchEvent(new CustomEvent('upcart:open'));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          })
          .catch(function (err) { if (msg) msg.textContent = err && err.message ? err.message : 'Could not add to cart.'; })
          .then(function () { busy = false; btn.removeAttribute('aria-busy'); });
      };
      btn.addEventListener('click', add);
      form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    }
  }
  function boot() {
    document.querySelectorAll('.ntk-hero[data-ntk-hero]').forEach(function (r) {
      if (r.getAttribute('data-ntk-init')) return;
      r.setAttribute('data-ntk-init', '1');
      initHero(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntk-review-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var rail = root.querySelector('[data-ntk-rail]'); if (!rail) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var step = function () { var c = rail.querySelector('.rc'); return c ? c.offsetWidth + 16 : 316; };
    root.querySelectorAll('[data-ntk-rail-prev]').forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); }); });
    root.querySelectorAll('[data-ntk-rail-next]').forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); }); });
  }
  function boot() { document.querySelectorAll('[data-ntk-carousel]').forEach(function (r) { if (r.getAttribute('data-ntk-init')) return; r.setAttribute('data-ntk-init', '1'); init(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omx-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(root) {
    var list = root.querySelector('[data-omx-slides]');
    var slides = list ? [].slice.call(list.children) : [];
    var thumbs = [].slice.call(root.querySelectorAll('[data-omx-thumb]'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function setActive(i) {
      thumbs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-active', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    function go(i) {
      if (!slides[i]) return;
      list.scrollTo({ left: slides[i].offsetLeft - list.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (list && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.6) setActive(parseInt(e.target.getAttribute('data-i'), 10)); });
      }, { root: list, threshold: 0.6 });
      slides.forEach(function (sl) { io.observe(sl); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var modal = root.querySelector('[data-omx-modal]');
    if (modal && typeof modal.showModal === 'function') {
      root.querySelectorAll('[data-omx-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          var img = modal.querySelector('[data-mi="' + b.getAttribute('data-omx-open') + '"]');
          if (!img) return;
          modal.showModal(); img.scrollIntoView({ block: 'start' });
        });
      });
      var closeBtn = modal.querySelector('[data-omx-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }

    var form = root.querySelector('form[data-omx-form]');
    var btn = root.querySelector('[data-omx-atc]');
    var msg = root.querySelector('[data-omx-msg]');
    var dataEl = root.querySelector('[data-omx-variants]');
    var data = { variants: {} };
    try { if (dataEl) data = JSON.parse(dataEl.textContent); } catch (e) {}
    if (!form || !btn) return;
    var busy = false;
    function add() {
      if (busy || btn.disabled) return;
      busy = true; btn.setAttribute('aria-busy', 'true'); if (msg) msg.textContent = '';
      var body = new FormData(form);
      if (!body.get('quantity')) body.set('quantity', '1');
      fetch(root.getAttribute('data-cart-add') || '/cart/add.js', { method: 'POST', body: body, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }).catch(function () { return { ok: r.ok, j: {} }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to cart. Please try again.');
          // Omega owns the product-scoped browser/server AddToCart event and deduplication.
          if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
          if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
          else document.dispatchEvent(new CustomEvent('upcart:open'));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function (err) { if (msg) msg.textContent = err && err.message ? err.message : 'Could not add to cart.'; })
        .then(function () { busy = false; btn.removeAttribute('aria-busy'); });
    }
    btn.addEventListener('click', add);
    form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
  }
  function boot() {
    document.querySelectorAll('.omx-hero[data-omx-hero]').forEach(function (r) {
      if (r.getAttribute('data-omx-init')) return;
      r.setAttribute('data-omx-init', '1');
      initHero(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omx-ingredients"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-omx-ing-track]');
    if (!track) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function step(dir) {
      var card = track.firstElementChild;
      var w = card ? card.getBoundingClientRect().width + 20 : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
    }
    var p = root.querySelector('[data-omx-ing-prev]'), n = root.querySelector('[data-omx-ing-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  }
  function boot() {
    document.querySelectorAll('[data-omx-ing]').forEach(function (r) {
      if (r.getAttribute('data-omx-init')) return;
      r.setAttribute('data-omx-init', '1'); init(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omx-stills"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-omx-st-track]');
    if (!track) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function step(dir) {
      var card = track.firstElementChild;
      var w = card ? card.getBoundingClientRect().width + 14 : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
    }
    var p = root.querySelector('[data-omx-st-prev]'), n = root.querySelector('[data-omx-st-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  }
  function boot() {
    document.querySelectorAll('[data-omx-st]').forEach(function (r) {
      if (r.getAttribute('data-omx-init')) return;
      r.setAttribute('data-omx-init', '1'); init(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omxr-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(root) {
    var list = root.querySelector('[data-omxr-slides]');
    var slides = list ? [].slice.call(list.children) : [];
    var thumbs = [].slice.call(root.querySelectorAll('[data-omxr-thumb]'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function setActive(i) {
      thumbs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-active', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    function go(i) {
      if (!slides[i]) return;
      list.scrollTo({ left: slides[i].offsetLeft - list.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (list && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.6) setActive(parseInt(e.target.getAttribute('data-i'), 10)); });
      }, { root: list, threshold: 0.6 });
      slides.forEach(function (sl) { io.observe(sl); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var modal = root.querySelector('[data-omxr-modal]');
    if (modal && typeof modal.showModal === 'function') {
      root.querySelectorAll('[data-omxr-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          var img = modal.querySelector('[data-mi="' + b.getAttribute('data-omxr-open') + '"]');
          if (!img) return;
          modal.showModal(); img.scrollIntoView({ block: 'start' });
        });
      });
      var closeBtn = modal.querySelector('[data-omxr-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }

    var form = root.querySelector('form[data-omxr-form]');
    var btn = root.querySelector('[data-omxr-atc]');
    var msg = root.querySelector('[data-omxr-msg]');
    var dataEl = root.querySelector('[data-omxr-variants]');
    var data = { variants: {} };
    try { if (dataEl) data = JSON.parse(dataEl.textContent); } catch (e) {}
    if (!form || !btn) return;
    var busy = false;
    function add() {
      if (busy || btn.disabled) return;
      busy = true; btn.setAttribute('aria-busy', 'true'); if (msg) msg.textContent = '';
      var body = new FormData(form);
      if (!body.get('quantity')) body.set('quantity', '1');
      fetch(root.getAttribute('data-cart-add') || '/cart/add.js', { method: 'POST', body: body, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }).catch(function () { return { ok: r.ok, j: {} }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to cart. Please try again.');
          var inp = form.querySelector('input[name="id"]'); var v = inp && data.variants[inp.value];
          if (window.fbq && v) { try { window.fbq('track', 'AddToCart', { content_ids: [String(data.product_id)], content_type: 'product', value: v.raw / 100, currency: data.currency }); } catch (e) {} }
          if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
          if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
          else document.dispatchEvent(new CustomEvent('upcart:open'));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function (err) { if (msg) msg.textContent = err && err.message ? err.message : 'Could not add to cart.'; })
        .then(function () { busy = false; btn.removeAttribute('aria-busy'); });
    }
    btn.addEventListener('click', add);
    form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
  }
  function boot() {
    document.querySelectorAll('.omxr-hero[data-omxr-hero]').forEach(function (r) {
      if (r.getAttribute('data-omxr-init')) return;
      r.setAttribute('data-omxr-init', '1');
      initHero(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omxr-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot() {
    document.querySelectorAll('.omxr-rs').forEach(function (root) {
      if (root.getAttribute('data-init')) return; root.setAttribute('data-init', '1');
      var track = root.querySelector('[data-omxr-rs-track]');
      var dots = root.querySelector('[data-omxr-rs-dots]');
      if (!track || !dots) return;
      var cards = Array.from(track.children);
      var page = 0, perPage = 3, pages = 1;
      function draw() {
        perPage = window.matchMedia('(min-width: 761px)').matches ? 3 : 1;
        pages = Math.ceil(cards.length / perPage);
        dots.replaceChildren();
        for (var i = 0; i < pages; i++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'omxr-rs__dot'; b.dataset.page = i;
          b.setAttribute('aria-label', 'Show stories page ' + (i + 1));
          b.addEventListener('click', function () { go(Number(this.dataset.page)); });
          dots.appendChild(b);
        }
        sync();
      }
      function sync() {
        var step = cards[0].getBoundingClientRect().width + 24;
        page = Math.min(pages - 1, Math.max(0, Math.round(track.scrollLeft / (step * perPage))));
        Array.from(dots.children).forEach(function (d, i) { d.setAttribute('aria-current', i === page ? 'true' : 'false'); });
      }
      function go(n) {
        page = (n + pages) % pages;
        var step = cards[0].getBoundingClientRect().width + 24;
        track.scrollTo({ left: page * perPage * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      root.querySelectorAll('.omxr-rs__arrow').forEach(function (b) {
        b.addEventListener('click', function () { go(page + Number(b.dataset.dir)); });
      });
      // Dots follow the carousel with an IntersectionObserver rather than a scroll listener,
      // so swiping costs no main-thread work. Behaviour is identical to the reference section.
      if ('IntersectionObserver' in window) {
        var seen = new Set();
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target);
          });
          if (!seen.size) return;
          var first = cards.findIndex(function (c) { return seen.has(c); });
          if (first < 0) return;
          page = Math.min(pages - 1, Math.floor(first / perPage));
          Array.from(dots.children).forEach(function (d, i) { d.setAttribute('aria-current', i === page ? 'true' : 'false'); });
        }, { root: track, threshold: 0.6 });
        cards.forEach(function (c) { io.observe(c); });
      }
      window.addEventListener('resize', draw);
      draw();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papaya-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(root) {
    var list = root.querySelector('[data-papaya-slides]');
    var slides = list ? [].slice.call(list.children) : [];
    var thumbs = [].slice.call(root.querySelectorAll('[data-papaya-thumb]'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function setActive(i) {
      thumbs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-active', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    function go(i) {
      if (!slides[i]) return;
      list.scrollTo({ left: slides[i].offsetLeft - list.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (list && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.6) setActive(parseInt(e.target.getAttribute('data-i'), 10)); });
      }, { root: list, threshold: 0.6 });
      slides.forEach(function (sl) { io.observe(sl); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var modal = root.querySelector('[data-papaya-modal]');
    if (modal && typeof modal.showModal === 'function') {
      root.querySelectorAll('[data-papaya-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          var img = modal.querySelector('[data-mi="' + b.getAttribute('data-papaya-open') + '"]');
          if (!img) return;
          modal.showModal(); img.scrollIntoView({ block: 'start' });
        });
      });
      var closeBtn = modal.querySelector('[data-papaya-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }

    var form = root.querySelector('form[data-papaya-form]');
    var btn = root.querySelector('[data-papaya-atc]');
    var msg = root.querySelector('[data-papaya-msg]');
    var dataEl = root.querySelector('[data-papaya-variants]');
    var data = { variants: {} };
    try { if (dataEl) data = JSON.parse(dataEl.textContent); } catch (e) {}
    if (!form || !btn) return;
    var busy = false;
    function add() {
      if (busy || btn.disabled) return;
      busy = true; btn.setAttribute('aria-busy', 'true'); if (msg) msg.textContent = '';
      var body = new FormData(form);
      if (!body.get('quantity')) body.set('quantity', '1');
      fetch(root.getAttribute('data-cart-add') || '/cart/add.js', { method: 'POST', body: body, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }).catch(function () { return { ok: r.ok, j: {} }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to cart. Please try again.');
          // Omega owns the product-scoped browser/server AddToCart event and deduplication.
          if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
          if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
          else document.dispatchEvent(new CustomEvent('upcart:open'));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function (err) { if (msg) msg.textContent = err && err.message ? err.message : 'Could not add to cart.'; })
        .then(function () { busy = false; btn.removeAttribute('aria-busy'); });
    }
    btn.addEventListener('click', add);
    form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
  }
  function boot() {
    document.querySelectorAll('.papaya-hero[data-papaya-hero]').forEach(function (r) {
      if (r.getAttribute('data-papaya-init')) return;
      r.setAttribute('data-papaya-init', '1');
      initHero(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papaya-ingredients"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-papaya-ing-track]');
    if (!track) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function step(dir) {
      var card = track.firstElementChild;
      var w = card ? card.getBoundingClientRect().width + 20 : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
    }
    var p = root.querySelector('[data-papaya-ing-prev]'), n = root.querySelector('[data-papaya-ing-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  }
  function boot() {
    document.querySelectorAll('[data-papaya-ing]').forEach(function (r) {
      if (r.getAttribute('data-papaya-init')) return;
      r.setAttribute('data-papaya-init', '1'); init(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papaya-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-papaya-sl-track]');
    if (!track) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function step(dir) { track.scrollBy({ left: dir * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    var p = root.querySelector('[data-papaya-sl-prev]'), n = root.querySelector('[data-papaya-sl-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  }
  function boot() {
    document.querySelectorAll('[data-papaya-sl]').forEach(function (r) {
      if (r.getAttribute('data-papaya-init')) return;
      r.setAttribute('data-papaya-init', '1'); init(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papaya-stills"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-papaya-st-track]');
    if (!track) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function step(dir) {
      var card = track.firstElementChild;
      var w = card ? card.getBoundingClientRect().width + 14 : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
    }
    var p = root.querySelector('[data-papaya-st-prev]'), n = root.querySelector('[data-papaya-st-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  }
  function boot() {
    document.querySelectorAll('[data-papaya-st]').forEach(function (r) {
      if (r.getAttribute('data-papaya-init')) return;
      r.setAttribute('data-papaya-init', '1'); init(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
